<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <v-row dense class="align-center justify-space-between">
          <!-- Botón de regreso -->
          <v-col cols="auto">
            <v-btn icon @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
            <!-- <form-meta
              :data="registro"
              :remove-commit="'removerForestal'"
              :record-id="registro.id"
              @removed="$router.go(-1)"
            /> -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <span style="font-size: 30px">🌲</span>
          <div style="text-align: center" class="text-h4">
            {{
              nuevoforestal
                ? 'Crea Nueva Producción Forestal'
                : 'Producción y Venta Forestal'
            }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-h7">
            Agrega o Busca tu Foresta por Parcela o Venta en esta Finca
          </div>
        </v-col>
        <!--        <v-col cols="3">
          <form-meta
            :data="registro"
            :remove-commit="'removerForestal'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          />
        </v-col> -->
        <!--  <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son requeridos
          </div>
        </v-col> -->
        <v-col cols="12">
          <v-select
            ref="fincaSelect"
            v-model="registro.id_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            outlined
            :disabled="busquedaFin"
            @input="onFincaChange()"
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <!-- <v-col cols="6">
          <modal-establecimiento />
          <v-select
            v-model="registro.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="RUA"
          ></v-select>
        </v-col> -->
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-parcela />
          </div>
          <v-select
            ref="parcelaSelect"
            v-model="registro.id_parcela"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :rules="[r.required]"
            :items="parcelasPorId(registro.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Parcela *"
            :disabled="busquedaFin"
          />
        </v-col>
        <!--   <v-col cols="12">
          <div class="text-h6">Ciclo de la Producción</div>
        </v-col> -->
        <v-row align="center">
          <v-col cols="9">
            <v-combobox
              ref="fechaInicio"
              v-model="registro.fecha"
              :items="fechasSugeridas"
              label="Fecha Inicio de Plantación*"
              range-type="production"
              :rules="[r.required]"
              :date.sync="registro.fecha"
              placeholder="aaaa-mm-dd"
              outlined
              :disabled="busquedaFin"
              @change="validarFecha"
            >
            </v-combobox>
            <p v-if="errorin" style="color: red">{{ errorin }}</p>
          </v-col>
          <!--  <v-col cols="2" class="d-flex align-center">
            <v-icon
              @mousedown.prevent="onFechaChange"
              color="primary"
              style="cursor: pointer; font-size: 30px"
            >
              mdi-magnify
            </v-icon>
          </v-col> -->
          <v-col cols="2" class="d-flex align-center">
            <v-btn color="primary" block @mousedown.prevent="onFechaChange">
              Siguiente
            </v-btn>
          </v-col>
        </v-row>
        <!-- Mensaje de estado de búsqueda -->
        <v-col v-if="mensajeBusqueda" cols="12">
          <v-alert
            :type="tipoMensaje"
            :value="true"
            dismissible
            @input="limpiarMensaje"
          >
            {{ mensajeBusqueda }}
          </v-alert>
        </v-col>

        <!-- Indicador de carga -->
        <v-col v-if="buscandoRegistro && !nuevoforestal" cols="12">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          <div class="text-center text-body-2 mt-2">
            Buscando registro existente...
          </div>
        </v-col>
        <v-col cols="12">
          <v-divider
            style="border: 1.5px solid black; margin: 10px 0"
          ></v-divider>
        </v-col>

        <!-- <v-col cols="6">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha Fin"
            range-type="production"
            :date.sync="registro.fecha_fin"
            placeholder="aaaa-mm-dd"
            outlined
            @change="validarFechaf"
          >
          </v-text-field>
          <p v-if="errorinf" style="color: red">{{ errorinf }}</p>
        </v-col>  -->
        <!-- <v-col cols="6">
          <v-text-field
            v-model.number="registro.ciclo"
            :rules="[r.required, r.int]"
            label="Densidad de siembra (cuántos árboles por hectárea)"
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <template v-if="nuevoforestal || registro.id">
          <v-row class="pa-2" align="center" justify="space-around">
            <v-col cols="6" class="d-flex justify-center">
              <v-btn
                block
                large
                :color="
                  activeTab === 'produccion' ? 'green darken-3' : 'primary'
                "
                class="white--text font-weight-bold"
                elevation="4"
                @click="pmostrarPlantacion()"
              >
                <v-icon left>mdi-sprout</v-icon>
                1.Plantación
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-center">
              <v-btn
                block
                large
                :color="activeTab === 'venta' ? 'green darken-3' : 'primary'"
                class="white--text font-weight-bold"
                elevation="4"
                @click="pmostrarVenta()"
              >
                <v-icon left>mdi-axe</v-icon>
                2.Corte y Venta
                <!-- <v-icon left>mdi-currency-usd</v-icon>      -->
                <!-- icono de dinero -->
              </v-btn>
            </v-col>
          </v-row>

          <!-- listado dinámico de producciones forestales -->
          <v-row class="text-left" v-if="mostrarPlantacion">
            <v-col cols="8" align-self="start">
              <v-btn
                depressed
                block
                class="primary--text"
                @click="agregarProduccion"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar Plantación
              </v-btn>
            </v-col>
            <!--  <v-col cols="12">
              <div class="text-h7">
                Presione el boton agregar.
              </div>
            </v-col> -->
            <!--           <v-col :key="`${index}estatus`" cols="6" md="4">
            <v-select
              v-model="produccion.estatus"
              :items="estatus"
              label="Estatus"
              outlined
              disabled
            />
           </v-col> -->
            <v-col
              cols="12"
              v-if="indexEdicion !== null && registro.producciones.length > 0"
            >
              <v-card outlined class="pa-4 mb-4">
                <v-col cols="12">
                  <v-select
                    ref="especieSelect"
                    v-model="
                      registro.producciones[indexEdicion].id_rubro_forestal
                    "
                    :rules="[r.required]"
                    :items="rubros_filtrados"
                    item-text="descripcion"
                    item-value="id"
                    label="Especie*"
                    outlined
                  >
                    <!--  <template v-slot:selection="props">
                  <div v-text="props.item[props.parent.$props.itemText]" />
                  </template> -->
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].id_variedad"
                    :rules="[r.required]"
                    label="Variedad *"
                    outlined
                  ></v-text-field>
                </v-col>
                <!--  <v-col cols="12" md="5">
                  <v-text-field
                    v-model="registro.producciones[indexEdicion].fecha"
                    label="Fecha"
                    range-type="production"
                    placeholder="aaaa-mm-dd"
                    outlined
                    @change="() => validarFechap()"
                  >
                  </v-text-field>
                  <p v-if="errorp" style="color: red">{{ errorin }}</p>
                </v-col> -->

                <!-- <v-col :key="`${index}produccion`" cols="4" md="4">
            <v-text-field
              v-model.number="produccion.produccion"
              :rules="[r.required, r.float]"
              label="Producción*"
              outlined
            >
              <template v-slot:append>
                <unit-picker group="to_tuca" />
              </template>
            </v-text-field>
            </v-col> -->
                <v-col cols="12">
                  <v-text-field
                    ref="cantidadInput"
                    v-model.number="
                      registro.producciones[indexEdicion].produccion
                    "
                    :rules="[r.required, r.float]"
                    label="Cantidad de Especie *"
                    outlined
                  >
                    <!-- <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverProduccion"
                class="error--text"
                @click="removerProduccion(index)"
                >mdi-close</v-icon
                > -->
                  </v-text-field>
                </v-col>
                <v-row>
                  <v-col cols="6">
                    <v-btn color="primary" @click="guardarEntrada"
                      >Siguiente</v-btn
                    >
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn icon @click="removerProduccion(indexEdicion)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <!-- listado de producciones (entradas) -->
            <v-col
              cols="12"
              v-for="(item, index) in registro.producciones"
              :key="index"
            >
              <v-card
                outlined
                class="pa-0 custom-border"
                :style="
                  index === indexEdicion
                    ? 'border: 2.8px solid #ff9800;'
                    : 'border: 2.8px solid #4caf50;'
                "
                @click="editarPlantacion(index)"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong> Especie: </strong>
                      {{ descripcionRubro(item.id_rubro_forestal) }} - Variedad:
                      {{ item.id_variedad }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Cantidad: {{ item.produccion }}
                    </v-list-item-subtitle>
                    <!--   <v-list-item-subtitle class="text-right">
                      Fecha: {{ item.fecha || '' }}
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>

          <!-- <v-col cols="12">
          <div class="text-h6">Producciones o Raleo</div>
          </v-col> -->
          <!-- listado dinámico de producciones forestales -->

          <!-- <template v-for="(produccion, index) in registro.producciones">
                  <v-col :key="`${index}estatus`" cols="6" md="4">
            <v-select
              v-model="produccion.estatus"
              :items="estatus"
              label="Estatus"
              outlined
              disabled
            />
          </v-col>
          <v-col :key="`${index}rubro`" cols="4" md="4">
            <v-select
              v-model="produccion.id_rubro_forestal"
              :rules="[r.required]"
              :items="rubros_filtrados"
              item-text="descripcion"
              item-value="id"
              label="Especie*"
              outlined
              @input="debounceBuscarRegistroExistente"
            >
              <template v-slot:selection="props">
                <div v-text="props.item[props.parent.$props.itemText]" />
              </template>
            </v-select>
          </v-col>
          <v-col :key="`${index}superficie`" cols="6" md="6">
            <v-text-field
              v-model.number="produccion.superficie_ocupada"
              :rules="[r.required, r.float]"
              label="Tipo de Raleo*"
              outlined
            ></v-text-field>
          </v-col>
          <v-col :key="`${index}produccion`" cols="4" md="4">
            <v-text-field
              v-model.number="produccion.produccion"
              :rules="[r.required, r.float]"
              label="Producción*"
              outlined
            >
              <template v-slot:append>
                <unit-picker group="to_tuca" />
              </template>
            </v-text-field>
          </v-col>
          <v-col :key="`${index}anual`" cols="6" md="6">
            <v-text-field
              v-model.number="produccion.ingreso_anual"
              :rules="[r.required, r.float]"
              label="Diametro a la altura del pecho"
              outlined
            >
              <v-icon
                slot="append-outer"
                :disabled="!puedeRemoverProduccion"
                class="error--text"
                @click="removerProduccion(index)"
                >mdi-close</v-icon
              >
            </v-text-field>
          </v-col>
          </template>  -->
          <!-- <v-col cols="8">
          <v-btn
            depressed
            block
            class="primary--text"
            @click="agregarProduccion"
          >
            <v-icon left>mdi-plus</v-icon>
            Agregar Raleo o Producción
          </v-btn>
          </v-col> -->
          <!-- Situación de desastre -->
          <!-- <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
          </v-col>
          <situacion-de-desastre
          v-for="(desastre, index) in registro.desastres"
          :key="desastre.id_trxdano"
          :form="registro.desastres[index]"
          :modulo="'FORESTAL'"
          @eliminar="eliminarDesastre(index)"
          /> -->

          <!-- listado dinámico de destinos -->
          <div v-if="mostrarVenta" style="margin-top: 5px">
            <destino
              :destinos="registro.destinos"
              :producciones="[registro.cosecha]"
              :listado-destinos="destino"
              :unit-picker="{ group: 'to_tuca' }"
              :rubros="rubro_forestal"
              :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
              tipo-produccion="forestal"
            />
          </div>
          <v-col cols="12">
            <div class="text-h6">Tareas Pendientes y Observaciones</div>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="registro.observacion"
              :rules="[r.max(1000)]"
              label="Tarea_Pendiente, Fecha, Observación"
              auto-grow
              outlined
              rows="1"
            ></v-textarea>
          </v-col>
        </template>
      </v-row>
    </v-form>

    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import Form from '@/components/js/Form'
import debounce from 'lodash.debounce'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import { danotrx, produccion_apicola } from '../../modelos'
import { produccion_forestal, formulario_forestal } from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
//import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
//import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Forestal',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    //ModalEstablecimiento,
    //SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      activeTab: 'produccion',
      esEditable: true,
      busquedaFin: false,
      fechita: '',
      indexEdicion: null,
      mostrarPlantacion: true,
      mostrarVenta: false,
      findeBusqueda: false,
      nuevoforestal: false,
      registroEncontrado: false,
      mensajeBusqueda: '',
      tipoMensaje: 'info',
      buscandoRegistro: false,
      errorin: '',
      errorinf: '',
      errorp: '',
      tabla_principal_id: 'id',
      tabla_produccion_id: 'id_forestal',
      tabla_produccion_id_rubro: 'id_rubro_forestal',
      ruta_registros: 'forestales',
      ruta_registro: 'forestal',
      nombre_registros_en_state: 'forestales',
      nombre_registro_en_state: 'forestal',
      dispatch_get_registro: 'getForestal',
      dispatch_guardar_registro: 'guardarForestal',
      registro: clona(formulario_forestal),
      registro_produccion: clona(produccion_forestal),
    }
  },
  computed: {
    ...mapState('listados', ['rubro_forestal']),
    ...mapGetters('registros', ['parcelasPorId', 'productor_actual']),
    //Con esta función solo se puede selecionar un rubro a la vez
    //y aqui solo tenemos un rubro(madera) no se puede poner disabled
    //para no editar esta funcion se hizo otra abajo
    /*  rubros_filtrados() {
      const selected = this.registro.producciones.map(
        (v) => v[this.tabla_produccion_id_rubro]
      )
      return this.rubro_forestal.map((v) => ({
        ...v,
        disabled: selected.includes(v.id),
      }))
    }, */

    fechasSugeridas() {
      const forestales = this.$store.state.registros.forestales
      if (!this.registro.id_finca || !this.registro.id_parcela) return []

      const fechas = Object.values(forestales)
        .filter(
          (f) =>
            f.id_finca === this.registro.id_finca &&
            f.id_parcela === this.registro.id_parcela
        )
        .map((f) => f.fecha)

      return [...new Set(fechas)].sort((a, b) => b.localeCompare(a))
    },
    camposIdentificacionDeshabilitados() {
      return !!this.registro.id // Retorna true si registro.id tiene un valor (es decir, el registro ya existe)
    },
    rubros_filtrados() {
      return this.rubro_forestal
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Forestal')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
      //para que cuando se habre un registro no este activo la busqueda
      this.busquedaFin = true
      //mostrar las fecha en formato dd-mm-aaaa en el front
      /*  this.fechita = this.formatearFechaParaFormulario(this.registro.fecha)
      if (
        this.registro.producciones &&
        Array.isArray(this.registro.producciones)
      ) {
        this.registro.producciones.forEach((produccion) => {
          if (produccion.fecha) {
            produccion.fecha = this.formatearFechaParaFormulario(
              produccion.fecha
            )
          }
        })
      } */
    } else {
      this.registro = clona(formulario_forestal)
      this.registro.producciones = []
      this.busquedaFin = false // Permite buscar normalmente
    }

    this.registro.id_productor = this.productor_actual

    if (!this.registro.ciclo) {
      this.registro.ciclo = 1
    }
  },
  methods: {
    registroNoEncontrado() {
      this.mensajeBusqueda = 'Este registro aún no lo has registrado, continua, Vas bien!'
      this.tipoMensaje = 'info'
      this.nuevoforestal = true
      this.crearNuevoRegistro()
    },
    async crearNuevoRegistro() {
      const { id_finca, id_parcela, fecha } = this.registro

      if (this.$route.path !== '/ru/forestal') {
        await this.$router.push('/ru/forestal')
      }
      this.registro = clona(formulario_forestal)

      this.registro.id_productor = this.productor_actual

      this.registro.id_finca = id_finca
      this.registro.id_parcela = id_parcela
      this.registro.fecha = fecha
      this.registro.producciones = []
      this.indexEdicion = null
      this.esEditable = true
      this.busquedaFin = true
    },

    onFincaChange() {
      if (this.busquedaFin) return
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar la función para buscar registro
      this.debounceBuscarRegistroPorCriterios()
    },

    onParcelaChange() {
      if (this.busquedaFin) return
      // Ejecutar la función original para cargar fincas/parcelas disponibles
      this.debounceBuscarRegistroExistente()
      // Ejecutar nuestra función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    async onFechaChange() {
      // 1) Forzar que el texto escrito quede en el modelo antes de validar
      const cb = this.$refs.fechaInicio
      if (
        cb &&
        cb.internalSearch != null &&
        cb.internalSearch !== this.registro.fecha
      ) {
        this.registro.fecha = cb.internalSearch.trim()
      }
      await this.$nextTick() // espera a que Vue actualice

      // 2) Validar con el valor ya actualizado
      const camposValidos =
        this.$refs.fincaSelect.validate() &&
        this.$refs.parcelaSelect.validate() &&
        this.$refs.fechaInicio.validate()

      if (!camposValidos) {
        this.$store.commit('ui/setSnack', {
          text: 'Verifique los elementos en rojo',
          color: 'error',
        })
        return
      }

      if (!this.validarFecha()) {
        return
      }

      if (this.busquedaFin) return

      // Ejecutar función para buscar registro por criterios
      this.debounceBuscarRegistroPorCriterios()
    },

    debounceBuscarRegistroPorCriterios: debounce(async function () {
      await this.buscarRegistroPorCriterios()
    }, 1000),

    async buscarRegistroPorCriterios() {
      // Si la búsqueda inicial ya se completó, no hagas nada más.
      if (this.busquedaFin) {
        return
      }

      if (
        !this.registro.id_finca ||
        !this.registro.id_parcela ||
        !this.registro.fecha
      ) {
        this.limpiarMensaje()
        return
      }
      this.buscandoRegistro = true
      this.limpiarMensaje()
      try {
        const registroExistente = this.buscarRegistroLocal()
        if (registroExistente) {
          await this.traerRegistroYNavegar(registroExistente)
        } else {
          // Si no está en local, buscar en servidor
          await this.buscarRegistroEnServidor()
        }
      } catch (error) {
        this.registroNoEncontrado()
      } finally {
        this.buscandoRegistro = false
        this.busquedaFin = true
      }
    },
    buscarRegistroLocal() {
      // Buscar en el store de forestales
      const forestales = this.$store.state.registros.forestales
      return Object.values(forestales).find(
        (forestal) =>
          forestal.id_finca === this.registro.id_finca &&
          forestal.id_parcela === this.registro.id_parcela &&
          forestal.fecha === this.registro.fecha
      )
    },
    async buscarRegistroEnServidor() {
      try {
        const response = await this.$store.dispatch(
          'registros/listarForestalesx',
          {
            id_productor: this.registro.id_productor,
            id_finca: this.registro.id_finca,
            id_parcela: this.registro.id_parcela,
            fecha: this.registro.fecha,
          }
        )

        if (response && response.success && Array.isArray(response.data)) {
          const fechaBuscada = this.registro.fecha
          const registroExacto = response.data.find((r) => {
            const fechaApi = r.fecha ? r.fecha.split('T')[0] : null
            return fechaApi === fechaBuscada
          })

          if (registroExacto) {
            await this.traerRegistroYNavegar(registroExacto)
          } else {
            this.registroNoEncontrado()
          }
        } else {
          this.registroNoEncontrado()
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.registroNoEncontrado()
        } else {
          throw error
        }
      }
    },

    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getForestal', { id: registro.id })
      }
      this.$router.push(`/ru/forestal/${registro.id}`)
      this.esEditable = false
      this.busquedaFin = true
    },

    mostrarMensaje(mensaje, tipo) {
      this.mensajeBusqueda = mensaje
      this.tipoMensaje = tipo
    },

    limpiarMensaje() {
      this.mensajeBusqueda = ''
      this.tipoMensaje = 'info'
    },
    pmostrarPlantacion() {
      this.mostrarPlantacion = true
      this.mostrarVenta = false
      this.activeTab = 'produccion'
    },
    pmostrarVenta() {
      this.mostrarPlantacion = false
      this.mostrarVenta = true
      this.activeTab = 'venta'
    },
    agregarProduccion() {
      this.registro.producciones.unshift(clona(this.registro_produccion))
      this.indexEdicion = 0
    },

    validarFecha() {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // formato aaaa-mm-dd
      const fecha = this.registro.fecha

      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar la fecha en el formato correcto: aaaa-mm-dd'
        return false
      }

      // Extraer año, mes y día del match
      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.errorin = 'El mes debe estar en el rango de 1 a 12.'
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate() // último día del mes
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        return false
      }

      this.errorin = '' // todo bien
      return true
    },

    validarFechap() {
      const fecha = this.registro.producciones[this.indexEdicion].fecha
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // formato aaaa-mm-dd

      if (!regexFecha.test(fecha)) {
        this.errorp =
          'Favor colocar la fecha en el formato correcto: aaaa-mm-dd'
        this.errorin = ''
        return false
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.errorp = `El mes debe estar en el rango de 1 a 12.`
        this.errorin = ''
        return false
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorp = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        this.errorin = ''
        return false
      }

      this.errorp = ''
      this.errorin = ''
      return true
    },
    validarFechaf() {
      // Tu lógica de validación para la fecha de inicio
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      const fecha = this.registro.fecha_fin
      if (!regexFecha.test(fecha)) {
        this.errorinf =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
      } else {
        let [, anio, mes, dia] = fecha.match(regexFecha)
        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.errorinf = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        let diasEnMes = new Date(anio, mes, 0).getDate()
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.errorinf = 'El día no es válido para el mes especificado.'
          return
        }
        this.errorinf = ''
      }
    },
    descripcionRubro(id) {
      const act = this.rubros_filtrados.find((a) => a.id === id)
      return act ? act.descripcion : 'Desconocido'
    },
    descripcionVariedad(id) {
      const act = this.rubros_filtrados.find((a) => a.id === id)
      return act ? act.descripcion : 'Desconocido'
    },
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela
        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_rubro_forestal)
              .map((prod) => prod.id_rubro_forestal)
          : []
        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        // required fields to be fulfilled
        if (ciclo && fecha && id_finca && rubros) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarForestalesx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    limpiarRegistrosVacios() {
      this.registro.destinos = (this.registro.destinos || []).filter((item) =>
        this.esDestinoValido(item)
      )
      this.$nextTick(() => {})
    },
    esDestinoValido(destino) {
      return destino.rubro
    },

    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    //Función que formatea la fecha que que se trae de la BD para mostrarla en el front
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },
    async antesDeGuardar() {
      // Limpiar registros vacíos
      this.limpiarRegistrosVacios()
      // Formatear fechas antes de guardar
      /* this.registro.fecha = this.formatearFechaParaBD(this.fechita)
           this.registro.producciones.forEach((produccion, index) => {
            produccion.fecha = this.formatearFechaParaBD(produccion.fecha)
          }) */
      await this.$nextTick()
      //  Evitar navegación redundante
      if (this.$route.path === `/ru/${this.ruta_registros}`) {
        this.ruta_registros = ''
      }
      this.guardarYContinuar()
    },
    guardarEntrada() {
      const camposValidos =
        this.$refs.cantidadInput.validate() &&
        this.$refs.especieSelect.validate()

      if (!camposValidos) {
        this.$store.commit('ui/setSnack', {
          text: 'Debe llenar Especie y Cantidad antes de continuar',
          color: 'error',
        })
        return
      }

      this.indexEdicion = null
    },

    Cancelar() {
      this.$router.push('/ru/forestal')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
    editarPlantacion(index) {
      this.indexEdicion = index
    },
  },
}
</script>

<style>
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
